import StoreUtil from '@/store/StoreUtil'
import ContractPlanDocument from '@/store/stores/collectionModule/documents/plan/ContractPlanDocument'

/**
 * クーポン利用に関するhook
 */
export default function useCouponUsage() {
  const contractInfoStore = StoreUtil.useStore('ContractInfoStore')
  const { contractPlans: masterContractPlans } = contractInfoStore

  /**
   * プランマスタの情報を取得
   */
  const getPlanMaster = (contractPlanId: string | null | undefined) =>
    masterContractPlans.value.find((plan) => plan.contractPlanId === contractPlanId)

  /**
   * 過去に有料機能を使ったことがあるかどうかを判定する
   * freePlan以外の契約プランがある場合は、有料機能を使ったことがあると判断する
   * 有料機能を使ったことがある: 月額プラン、年額プラン、クーポンプラン、ワンタイムパスプランなどを過去に契約したことがある
   */
  const hasUsedPaidFeaturesBefore = (contractedPlans: Array<ContractPlanDocument> | undefined) =>
    contractedPlans?.some((plan) => {
      if (plan.couponId) {
        // クーポン/ワンタイムパスを利用したことがある場合の処理
        return true
      }
      const targetPlan = getPlanMaster(plan.contractPlanId ?? '')
      return targetPlan?.planGroupId !== 'freePlan'
    })

  return {
    hasUsedPaidFeaturesBefore,
  }
}
